<template>
  <el-dialog
    title="修改密码"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="p20" style="padding-bottom: 100px;">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="名称" prop="name">
          <el-input type="text" v-model="form.name"  placeholder="请输入名称" class="max-w460"></el-input>
        </el-form-item>
      <el-form-item label="类型">
            <el-select v-model="form.code"  prop="code">
                <el-option :label="item.name" v-for="(item,index) in codes" :key="index" :value="item.value"></el-option>
            </el-select>
        </el-form-item>  
        

        <el-form-item label="拥有者"  prop="owner">
          <el-input type="text" v-model="form.owner" placeholder="请输入拥有者" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="邮箱" prop="email">
          <el-input type="text" v-model="form.email" placeholder="请输入邮箱" class="max-w460"></el-input>
       </el-form-item>

      

       <el-form-item label="账号" prop="account">
          <el-input type="text" v-model="form.account" placeholder="请输入账号" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="密码" prop="password">
          <el-input type="password" v-model="form.password" placeholder="请输入密码" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="主手机号"  prop="mobile_one">
          <el-input type="text" v-model="form.mobile_one" placeholder="请输入主手机号" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="备手机号"  prop="mobile_two">
          <el-input type="text" v-model="form.mobile_two" placeholder="请输入备手机号" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="网址"  prop="url">
          <el-input type="text" v-model="form.url" placeholder="请输入网址" class="max-w460"></el-input>
       </el-form-item>

       <el-form-item label="备注"  prop="remark">
        <div class="edit_container">
          <Uediter :text="form.remark" class="max-w460" :config="ueditor.config" ref="ue" @contentChange="contentChangeFunc"></Uediter>
        </div>
      </el-form-item>
        <el-form-item label="状态"  prop="status">
          <el-radio-group v-model="form.status" class="max-w460">
                <el-radio  :label="0" :value="0" >正常</el-radio>
                <el-radio  :label="1" :value="1">冻结</el-radio>
            </el-radio-group>
       </el-form-item>

       <div class="common-form">关联数据</div>

       <el-form-item label="关联公司" >
     
          <el-button icon="el-icon-plus" v-if="company.name==''" @click="chooseCompany">选择公司</el-button>
          <el-button icon="el-icon-plus" v-if="company.name" @click="chooseCompany">重新选择</el-button>
       
        <div v-if="company.name">您选择了:<span style="font-weight: 600;">{{ company.name }}</span></div>
       </el-form-item>

       
       <el-form-item label="关联用户" >
     
     <el-button icon="el-icon-plus" v-if="user.name==''" @click="chooseUser">选择用户</el-button>
     <el-button icon="el-icon-plus" v-if="user.name" @click="chooseUser">重新选择</el-button>
  
   <div v-if="user.name">您选择了:<span style="font-weight: 600;">{{ user.name }}</span></div>
  </el-form-item>


  
  <el-form-item label="关联资产" >
     
     <el-button icon="el-icon-plus" v-if="asset.name==''" @click="chooseAsset">选择资产</el-button>
     <el-button icon="el-icon-plus" v-if="asset.name" @click="chooseAsset">重新选择</el-button>
  
   <div v-if="asset.name">您选择了:<span style="font-weight: 600;">{{ asset.name }}</span></div>
  </el-form-item>


       
      
  

       <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">添加</el-button>

      </div>
      </el-form>

      <Company :company_show = "company_show" v-if="company_show"
    :islist="false"  :excludeIds_company="excludeIds_company"  @closeDialog="closeDialogFunc_company"
    ></Company>
    <User :is_open = "user_show" v-if="user_show"
    :multi="false"  :excludeIds_user="excludeIds_user"  @close="closeDialogFunc_user"
    ></User>
    <Asset :asset_show = "asset_show" v-if="asset_show"
    :multi="false"  :excludeIds_user="excludeIds_asset"  @closeDialogFunc_asset="closeDialogFunc_asset"
    ></Asset>
    </div>
  
   
  </el-dialog>
</template>

<script>
import PasswordApi from '@/api/password.js';
import Uediter from '@/components/UE.vue';
import Company from '@/components/company/company';
import Asset from '@/components/asset/asset';
import User from '@/components/user/GetUser';
export default {
  components: {
    /*编辑器*/
    Uediter,
    Company,
    User,
    Asset
  },
  data() {
    return {
      /*富文本框配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      order_id: 0,
      loading: false,
      /*左边长度*/
      formLabelWidth: "100px",
      /*是否显示*/
      dialogVisible: true,
      codes:[],//类型
      form:{
        name:"",//名称
        code:"common",//类型
        owner:"",//拥有者
        email:"",//邮箱
        account:"",//账号
        password:"",//密码
        mobile_one:"",//主手机号
        mobile_two:"",//备手机号
        url:"",//网址
        remark:"",//备注
        status:0,
        user_id:"",
        company_id:"",
        user_asset_id:""

      },
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        code: [{ required: true, message: '请选择类型', trigger: 'blur' }],
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        mobile_one: [{ required: true, message: '请输入主手机号', trigger: 'blur' }],
      },
      company_show:false,
      excludeIds_company:[],
      company:{//选择的公司
        company_id:"",
        name:""
      },
      user_show:false,
      excludeIds_user:[],
      user:{//选择的用户
        user_id:"",
        name:""
      },

      asset_show:false,
      excludeIds_asset:[],
      asset:{//选择的资产
        user_asset_id:"",
        name:""
      },
    };
  },
  props: ["dataModel","password_id"],
  created() {
    this.getData();
  },
  methods: {
     /*获取富文本内容*/
     contentChangeFunc(e){
      this.form.remark=e;
    },
    chooseCompany(){//选择公司
      this.company_show = true;
    },
    chooseUser(){//选择用户
      this.user_show = true;
    },
    chooseAsset(){//选择资产
      this.asset_show = true;
    },
    /*获取参数*/
    getData() {
       //获取类型
       var self = this;
        PasswordApi.getCode({}).then(data => {
            self.codes = data.data;
          }).catch(error => {
        });
        PasswordApi.detail({
          "password_id":self.password_id
        }).then(data => {
          console.log(data.data);

            self.form = data.data;
            self.form.code = data.data.code.value
            self.form.status = data.data.status.value
            self.company = {
              company_id:data.data.company_id,
              name:data.data.company_name?data.data.company_name:"",
            }
            self.user = {
              user_id:data.data.user_id,
              name:data.data.user_nickName?data.data.user_nickName:"",
            }
            self.asset = {
              asset_id:data.data.user_asset_id,
              name:data.data.user_asset_name?data.data.user_asset_name:"",
            }
          }).catch(error => {
        });
        
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("closeDialog", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },
    onSubmit(){//修改密码
      var self = this;
      var parmas = self.form;
      parmas.password_id = self.password_id
      parmas.company_id = self.company.company_id
      parmas.user_id = self.user.user_id
      parmas.user_asset_id = self.asset.user_asset_id
      parmas.is_delete =parmas.is_delete.value
      console.log("parmas",parmas)
      if(parmas.code == ""){
        self.$message({
                message:"请选择类型",
                type: 'error'
              });
              return
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          PasswordApi.edit(parmas).then(data => {
            if(data.code == 1){
              self.$message({
                message: data.msg,
                type: 'success'
              });
              this.dialogFormVisible("success")
            }
          }).catch(error => {
            self.$message({
                message:"修改失败",
                type: 'error'
              });
        });
        }

      });
    },
      /*关闭弹窗*/
      closeDialogFunc_company(e) {
      console.log(e)
      let self = this;
      self.company_show = false;
      if (e.type === 'success') {
        self.company = {
          company_id:e.params[0].company_id,
          name:e.params[0].name,
        }
        self.excludeIds_company = [e.params[0].company_id]
      }
    },
     /*关闭弹窗*/
     closeDialogFunc_user(e) {
      console.log(e)
      let self = this;
      self.user_show = false;
      if (e.type === 'success') {
        self.user = {
          user_id:e.params.user_id,
          name:e.params.nickName,
        }
        self.excludeIds_user = [e.params.user_id]
      }
    },
     /*关闭弹窗*/
     closeDialogFunc_asset(e) {
      console.log(e)
      let self = this;
      self.asset_show = false;
      if (e.type === 'success') {
        self.asset = {
          user_asset_id:e.params[0].user_asset_id,
          name:e.params[0].name,
        }
        self.excludeIds_asset = [e.params[0].user_asset_id]
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/password/dialog/Edit.vue